import { EventEmitter } from "events";
import Dispatcher from './AppDispatcher';

import AppActionTypes from './AppActionTypes';

import NAV from '../navigation';
import { tickets } from '../data/index';

let path = "";
let hidden = true;

try {
    path = window.location.pathname.split('/')[1];
    Object.keys(NAV).forEach(key => {
        if (path !== "" && path !== "intro" && NAV[key] === path) {
            hidden = false;
        }
    })
} catch (error) {

}

let _store = {
    _animations: {
        intro: false,
        theme: false
    },
    _header: {
        hidden,
        collapsed: false,
        speaker: false
    },
    _navigation: {
        back: '',
        location: path
    },
    _speaker: {
        speaker: null,
        move: null,
        position: 0,
    },
    _modal: {
        stream: false
    }
}

class AppStore extends EventEmitter {

    constructor() {
        super();
        Dispatcher.register(this._registerActions);
    }

    //////////////////////////////////////////////////////////

    _setAnimations = (data) => {
        _store._animations = Object.assign(_store._animations, data);
        this.emit(AppActionTypes.ANIMATION, _store._animations);
    }

    getAnimations = () => {
        return _store._animations;
    }

    //////////////////////////////////////////////////////////

    _setHeader = (data) => {
        _store._header = Object.assign(_store._header, data);
        this.emit(AppActionTypes.HEADER, _store._header);
    }

    getHeader = () => {
        return _store._header;
    }

    //////////////////////////////////////////////////////////

    _setNavigation = (data) => {
        if (data.location === NAV.TICKETS) {
            window.open(tickets, "_blank");
            return;
        }
        _store._navigation = Object.assign(_store._navigation, Object.assign(data, { back: _store._navigation.back }));
        this.emit(AppActionTypes.NAVIGATION, _store._navigation);
    }

    getNavigation = () => {
        return _store._navigation;
    }

    //////////////////////////////////////////////////////////

    _setSpeaker = (data) => {
        _store._speaker = Object.assign(_store._speaker, data);
        this.emit(AppActionTypes.SPEAKER, _store._speaker);
    }

    getSpeaker = () => {
        return _store._speaker;
    }

    //////////////////////////////////////////////////////////

    _setModal = (data) => {
        _store._modal = Object.assign(_store._modal, data);
        this.emit(AppActionTypes.MODAL, _store._modal);
    }

    getModal = () => {
        return _store._modal;
    }

    //////////////////////////////////////////////////////////


    _registerActions = (action) => {
        const { type, data, callback } = action;

        if (this[type] && typeof this[type] === 'function') {
            this[type](data);

            if (callback && typeof callback === 'function') {
                // hack for cannot dispatch in the middle of a dispatch
                setTimeout(() => {
                    callback();
                }, 25)
            }
        }

    }
}

export default new AppStore();



